<template>
  <hm-content title="">
    <div class="flex flex-start mb10">
      当前供货商: <span class="primary">{{ storeNames }}</span>
    </div>
    <div class="table-panel flex flex-between flex-wrap">
      <div class="mr10">
        <el-button type="primary" size="small" @click="addAct"
          >添加活动
        </el-button>
        <!-- <el-button type="primary" size="small" @click="brokerage"
          >推会员返佣</el-button
        > -->
      </div>
      <div class="flex text-right item-center flex-wrap">
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="选择商户"
          v-model="searchCondition.storeCode"
          style="width: 200px"
          :remote-method="remoteMethod"
          filterable
          remote
        >
          <el-option
            v-for="item in storeBasicInfoListBoxList"
            :key="item.storeCode"
            :label="item.storeName"
            :value="item.storeCode"
          ></el-option>
        </el-select>
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.keyWords"
          size="small"
          placeholder="请输入"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            size="small"
            style="width: 100px"
            v-model="searchCondition.queryType"
          >
            <el-option label="商品名" value="goodsName"></el-option>
            <!-- <el-option label="货号" value="goods_sn"></el-option> -->
            <el-option label="商品条码" value="goodsBarcode"></el-option>
          </el-select>
        </el-input>
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.rewardName"
          placeholder="请输入活动名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-cascader
          clearable
          class="mr10"
          ref="cascader"
          v-model="searchCondition.applyDepartIds"
          :props="propss"
          :show-all-levels="false"
          size="small"
          placeholder="请选择机构"
        ></el-cascader>
        <el-select
          size="small"
          clearable
          placeholder="选择活动上下线"
          v-model="searchCondition.enabledState"
          class="mr10"
          filterable
        >
          <el-option label="上线" value="yes"></el-option>
          <el-option label="下线" value="no"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="flex flex-end item-center mt10 mb10">
      <span @click="openTimeBatch" class="pointer mr10">
        <span class="delete-icon hmicon icon-xitong"></span>批量修改
      </span>
      <span @click="batchDelete" class="pointer mr10">
        <span class="delete-icon hmicon icon-shanchu"></span>批量删除
      </span>
      <el-button type="success" size="small" @click="outputExcelMerchant"
        >导出商户在线活动</el-button
      >
    </div>
    <div class="table">
      <el-table
        border
        @selection-change="getDelChecked"
        ref="brandTable"
        :data="supplierRewardRuleInfoList.records"
        style="width: 100%"
        id="table"
        size="small"
        :row-class-name="tableRowClassName"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rewardName"
          label="活动名称"
          width="150"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rewardMode"
          label="活动类型"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.rewardMode === 'collocation'">搭配活动</div>
            <div v-if="scope.row.rewardMode === 'fixed'">普通活动</div>
            <div v-if="scope.row.rewardMode === 'radio'">冲刺活动</div>
            <div v-if="scope.row.rewardMode === 'sub'">差异活动</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="applyDepartNames"
          show-overflow-tooltip
          label="活动组织"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="applyStoreCodesCount"
          label="适用商户数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsCount"
          label="适用商品数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="levelCount"
          label="活动规则阶梯"
        >
          <!-- <template slot-scope="scope">
            <div
              class="flex flex-center primary"
              v-if="scope.row.rewardMode === 'fixed'"
            >
              ¥{{ scope.row.rewardValue }}
            </div>
            <div
              class="flex flex-center blue"
              v-if="scope.row.rewardMode === 'radio'"
            >
              {{ scope.row.rewardValue }}%
            </div>
          </template> -->
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="活动创建时间"
          width="135"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="timeFormatValue"
          label="奖励时段"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.timeFormatValue }}
            <span
              class="hmicon icon-shuru blue pointer"
              @click="editTime(scope.row)"
            >
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="autoOfflineDaysLimt"
          label="自动下线"
        >
          <template slot-scope="scope">
            {{ scope.row.autoOfflineDaysLimt }}天
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditState"
          label="状态"
          width="135"
        >
        <template slot-scope="scope">
          <span v-if="scope.row.auditState == 'wait'">待审核</span>
          <span v-if="scope.row.auditState =='pass'">通过</span>
          <span v-if="scope.row.auditState =='reject'">拒绝</span>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsCount"
          label="上/下线"
        >
          <template slot-scope="scope">
            <div class="success" v-if="scope.row.enabledState === 'yes'">
              上线
            </div>
            <div class="danger" v-if="scope.row.enabledState === 'no'">
              <span v-if="scope.row.offlineMode === 'manual'"> 手动 </span>
              <span v-if="scope.row.offlineMode === 'day'"> 到期 </span>
              <span v-if="scope.row.offlineMode === 'balance'"> 余额不足 </span>
              下线
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="edit(scope.row, scope.$index)"
                >编辑
              </el-button>
              <el-button
                size="small"
                type="text"
                @click="edit(scope.row, scope.$index, 'detail')"
                v-if="scope.row.auditState == 'wait'"
                >审核
              </el-button>
              <el-button
                size="small"
                type="text"
                @click="copy(scope.row, scope.$index)"
                >复制
              </el-button>
              <!-- <el-button
                size="small"
                type="text"
                @click="onLine(scope.row, 'yes')"
                v-if="scope.row.enabledState === 'no'"
                >上线
              </el-button> -->
              <el-button
                size="small"
                type="text"
                @click="onLine(scope.row, 'no')"
                v-if="scope.row.enabledState === 'yes'"
                >下线
              </el-button>
            </div>
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="toDetails(scope.row, scope.$index)"
                >详情
              </el-button>
              <el-button size="small" type="text" @click="del(scope.row)"
                >删除
              </el-button>
              <el-button
                size="small"
                type="text"
                @click="operationLog(scope.row, scope.$index)"
                >操作日志
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="supplierRewardRuleInfoList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="新增活动"
      width="80%"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div>
        <div slot="header">
          <hm-step
            :steps="steps"
            :step="step"
            :disabledFirst="disabledFirst"
            disabledNext
          ></hm-step>
        </div>
      </div>
      <el-form
        v-show="step === 1"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="活动名称" prop="rewardName">
          <el-input
            type="text"
            v-model.trim="ruleForm.rewardName"
            clearable
            style="width: 600px"
            placeholder="请输入活动名称"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="适配商户类型" prop="adapterStoreType">
          <el-radio-group v-model="ruleForm.adapterStoreType">
            <el-radio :label="'norm'">普通商户</el-radio>
            <el-radio :label="'month'">月结商户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动时段" prop="validatorTime" ref="validatorTime">
          <hm-date-select
            title="活动"
            :isShow="isShow"
            :datePicker="datePicker"
            @swithRunningTimeType="swithRunningTimeType"
            ref="hmDateSelect"
            multipleTime
          ></hm-date-select>
        </el-form-item>
        <el-form-item label="活动下线" prop="autoOfflineDaysLimt">
          到期
          <el-input
            type="text"
            maxlength="8"
            @input="filterGt0OrFixed0('autoOfflineDaysLimt')"
            @mousewheel.prevent.native
            style="width: 100px"
            v-model.trim="ruleForm.autoOfflineDaysLimt"
            clearable
            placeholder=""
            size="small"
          ></el-input>
          天，活动下线
        </el-form-item>
      </el-form>
      <div v-show="step === 2">
        <div class="mb10">
          适配组织
          <el-cascader
            clearable
            @change="changgeaa"
            filterable
            style="width: 600px"
            class="mr10 applDepart"
            ref="cascader"
            v-model="ruleForm.applDepartId"
            :props="props"
            :show-all-levels="false"
            size="small"
            placeholder="请选择机构"
          ></el-cascader>
        </div>

        <div class="flex flex-between mb10">
          <div>
            <el-button
              type="primary"
              plain
              size="small"
              :disabled="!ruleForm.applDepartId.length"
              @click="merchantDialogVisible = true"
              >+
              {{
                ruleForm.adapterStoreType == "month"
                  ? "添加月结商户"
                  : "添加商户"
              }}
            </el-button>
            <el-input
              v-model="shopSearchVal"
              size="small"
              class="ml10"
              clearable
              placeholder="输入商户名称搜索"
            />
          </div>
          <div>
            <el-button @click="output" type="primary" size="small"
              >导出模板
            </el-button>
            <el-button
              v-if="!ruleForm.applDepartId.length"
              type="info"
              size="small"
              disabled
              >导入表格
            </el-button>
            <el-button
              v-else
              type="primary"
              size="small"
              class="open-file pointer"
              >导入表格
              <input
                type="file"
                class="pointer"
                @change="importfs"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </el-button>
            <span @click="batchRemoveShops" class="pointer ml10">
              <span class="delete-icon hmicon icon-shanchu"></span>批量删除
            </span>
          </div>
        </div>
        <div class="table mb10">
          <el-table
            stripe
            ref="shopRoleTable"
            height="400px"
            :data="
              shopList.filter(
                (data) =>
                  !shopSearchVal ||
                  data.storeName
                    .toLowerCase()
                    .includes(shopSearchVal.toLowerCase())
              )
            "
            style="width: 100%"
            id="table"
            size="small"
            @row-click="
              (row, column, e) => tableSelect(row, column, e, 'shopRoleTable')
            "
            border
            @selection-change="getShopBatchChecked"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="storeName"
              label="商户名称"
            ></el-table-column>

            <el-table-column
              label="操作"
              width="180px"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-tooltip class="item" content="删除" placement="top">
                    <div class="pointer mr10" @click="remove(scope.row)">
                      <span class="hmicon icon-shanchu primary"></span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-show="step === 3">
        <div class="flex flex-between item-center mb10">
          <div>
            <el-button type="primary" size="small" @click="addGoods"
              >添加商品
            </el-button>
            <el-input
              v-model="goodSearchVal"
              size="small"
              class="ml10"
              clearable
              style="width: 180px"
              placeholder="输入商品名称/条码搜索"
            />
          </div>
          <div class="flex flex-end" style="marginbottom: -20px">
            <div @click="outputExcel" class="delete mr20 pointer">
              <span class="delete-icon hmicon icon-daochu"></span>
              导出模板
            </div>
            <div class="delete mr20 pointer open-file">
              <span class="delete-icon hmicon icon-daoru"></span>
              导入商品
              <input
                type="file"
                @change="importf"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>
            <el-button type="text" size="small" @click="batchRemove"
              >批量删除
            </el-button>
          </div>
        </div>
        <div class="table mb10">
          <el-table
            stripe
            ref="goodRoleTable"
            :data="
              addGoodsList.filter(
                (data) =>
                  !goodSearchVal ||
                  data.goodsName
                    .toLowerCase()
                    .includes(goodSearchVal.toLowerCase()) ||
                  data.goodsBarcode
                    .toLowerCase()
                    .includes(goodSearchVal.toLowerCase())
              )
            "
            style="width: 100%"
            id="table"
            size="small"
            @row-click="
              (row, column, e) => tableSelect(row, column, e, 'goodRoleTable')
            "
            max-height="500px"
            border
            @selection-change="getBatchChecked"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="商品品牌"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsBarcode"
              label="商品条码"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="rewardBaseMoney"
              label="单件奖励"
              v-if="ruleForm.rewardMode === 'sub'"
            >
              <template slot-scope="scope">
                <el-input
                  type="text"
                  maxlength="8"
                  @input="
                    filterGt0OrGoodsListFixed2(scope.$index, 'rewardBaseMoney')
                  "
                  @mousewheel.prevent.native
                  style="width: 100px"
                  v-model.trim="scope.row.rewardBaseMoney"
                  clearable
                  placeholder=""
                  size="small"
                ></el-input>
                元
              </template>
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-tooltip class="item" content="删除" placement="top">
                    <div class="pointer mr10" @click="removeGoods(scope.row)">
                      <span class="hmicon icon-shanchu primary"></span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-show="step === 4">
        <div class="flex flex-between mb10">
          <!-- <div class="flex-1">活动名称：
            <span>{{ ruleForm.rewardName }}</span>            
          </div> -->
          <div class="flex-1 flex">
            活动名称：
            <div class="flex-1" @dblclick="changeRewardName()">
              <span v-show="edit_rewardName">
                {{ ruleForm.rewardName }}
              </span>
              <el-input
                ref="rewardNameinput"
                @blur="rewardNameblur()"
                @keyup.enter.native="$event.target.blur"
                clearable
                v-show="!edit_rewardName"
                size="small"
                style="width: 260px"
                v-model="ruleForm.rewardName"
                placeholder="请输入活动名称"
              ></el-input>
            </div>
          </div>
          <div class="flex-1" v-if="ruleForm.rewardMode === 'fixed'">
            活动类型：普通活动
          </div>
          <div class="flex-1" v-if="ruleForm.rewardMode === 'sub'">
            活动类型：差异活动
          </div>
          <div class="flex-1" v-if="ruleForm.rewardMode === 'radio'">
            活动类型：冲刺活动
          </div>
          <div class="flex-1">
            活动下线：到期<span class="blue">{{
              ruleForm.autoOfflineDaysLimt
            }}</span
            >天后自动下线
          </div>
          <div class="flex-1 flex flex-wrap">
            <div>适用时段：</div>

            <div
              class="flex flex-center blue"
              v-if="ruleForm.dateConfigMode === 'general'"
            >
              {{ ruleForm.rewardStartDate }}至{{ ruleForm.rewardEndDate }}
            </div>
            <div
              class="flex flex-center blue"
              v-if="ruleForm.dateConfigMode === 'special'"
            >
              <div v-if="ruleForm.dateType === 'date'">
                {{ ruleForm.rewardStartDate }}至{{
                  ruleForm.rewardEndDate
                }}的每{{ ruleForm.dateValue }}天
              </div>
              <div v-if="ruleForm.dateType === 'week'">
                {{ ruleForm.rewardStartDate }}至{{ ruleForm.rewardEndDate }}的
                <span v-for="(v, i) in ruleForm.dateValue" :key="i">
                  {{ i === 0 ? "" : "," }}每周{{ v }}</span
                >
              </div>
              <div v-if="ruleForm.dateType === 'month'">
                {{ ruleForm.rewardStartDate }}至{{ ruleForm.rewardEndDate }}的
                <span v-for="(v, i) in ruleForm.dateValue" :key="i">
                  {{ i === 0 ? "" : "," }}每月{{ v }}号</span
                >
              </div>
            </div>
          </div>

          <!-- <div class="flex-1">
            基础提成：
            <span v-if="ruleForm.rewardMode === 'fixed'" class="primary">
              ¥{{ ruleForm.rewardValue }}</span
            >
            <span v-if="ruleForm.rewardMode === 'radio'">
              {{ ruleForm.rewardValue }}%</span
            >
          </div>
          <div class="flex-1">
            活动条件：参与该活动的商品每满
            <span class="blue">{{ ruleForm.rewardNumberLimit }}</span>
            件为一组计算活动
          </div> -->
        </div>
        <div class="flex flex-between mb10">
          <div class="flex-1">
            适配组织：<span
              v-for="(v, i) in ruleForm.applyDepartNames"
              :key="i"
            >
              {{ i === 0 ? "" : "," }}{{ v }}</span
            >
          </div>
          <div class="flex-1 flex-wrap">
            活动备注：{{ ruleForm.rewardRemark }}
          </div>
        </div>

        <!-- <div class="flex flex-wrap mb10">
          <div class="flex-1">
            活动规则：
            <span v-for="(v, i) in ruleForm.ruleRelModelList" :key="i">
              参与活动商品每满{{ v.rewardNumberLimit }}件为一组,每组额外奖励{{
                v.rewardValue
              }}元.
            </span>
          </div>
        </div> -->

        <div class="title mb10">
          适用商户:
          <span class="blue" v-for="(v, i) in shopList" :key="i">
            {{ i === 0 ? "" : "," }}{{ v.storeName }}</span
          >
        </div>
        <div class="title mb10">
          活动规则:
          <span v-if="ruleForm.rewardMode === 'fixed'">普通活动</span>
          <span v-else-if="ruleForm.rewardMode === 'sub'">差异活动</span>
          <span v-else-if="ruleForm.rewardMode === 'radio'">冲刺活动</span>
        </div>
        <div class="table mb10" v-if="ruleForm.rewardMode === 'fixed'">
          <el-table
            stripe
            ref="roleTable"
            :data="ruleForm.ruleRelModelList"
            style="width: 500px"
            border
            id="table"
            max-height="500px"
            size="small"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="每组件数"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                每满{{ scope.row.rewardNumberLimit }}件为一组
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="每组额外奖励"
              prop="rewardValue"
            >
              <template slot-scope="scope">
                {{ scope.row.rewardValue }}元
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table mb10" v-if="ruleForm.rewardMode === 'sub'">
          <el-table
            :data="ruleForm.ruleRelModelList"
            style="width: 100%"
            ref="table"
            stripe
            max-height="500px"
            size="small"
            :show-header="showHeader"
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="start"
              label="每组件数"
              width="700"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                买
                {{ scope.row.rewardNumberLimit }}
                件, 送
                {{ scope.row.rewardSubNum }}
                件,X{{
                  new Number(scope.row.rewardNumberLimit) +
                  new Number(scope.row.rewardSubNum)
                }}件为一组，发放
                {{ scope.row.rewardNumberLimit }}件商品的单件奖励, 每组额外奖励
                {{ scope.row.rewardValue }}
                元
              </template>
            </el-table-column>

            <!-- <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-if="scope.$index === 0"
                      size="small"
                      @click="addChild(scope.$index)"
                      type="text"
                      >新 增</el-button
                    >
                    <el-button
                      v-else
                      size="small"
                      @click="delRule(scope.$index)"
                      class="danger"
                      type="text"
                      >删 除</el-button
                    >
                  </div>
                </template>
              </el-table-column> -->
          </el-table>
        </div>
        <div class="table mb10" v-if="ruleForm.rewardMode === 'radio'">
          <el-table
            stripe
            ref="roleTable"
            :data="ruleForm.ruleRelModelList"
            style="width: 500px"
            border
            id="table"
            size="small"
            max-height="500px"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="冲刺门槛"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                {{ scope.row.rewardNumberLimit }}件
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="额外奖励"
              prop="rewardValue"
            >
              <template slot-scope="scope">
                每件额外奖励{{ scope.row.rewardValue }}元
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="title mb10">适用商品</div>
        <div class="table mb10">
          <el-table
            stripe
            ref="roleTable"
            :data="addGoodsList"
            style="width: 100%"
            id="table"
            size="small"
            border
            max-height="500px"
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="商品品牌"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsBarcode"
              label="商品条码"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="rewardBaseMoney"
              label="单件奖励"
              v-if="ruleForm.rewardMode === 'sub'"
            >
            </el-table-column>

            <!-- <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-tooltip class="item" content="删除" placement="top">
                    <div
                      class="pointer mr10"
                      @click="removeGoods(scope.$index)"
                    >
                      <span class="hmicon icon-shanchu primary"></span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
      <div class="btn-wrapper flex flex-center">
        <!-- <el-button size="small" @click="dialogVisible = false">取 消</el-button> -->
        <el-button
          size="small"
          type="primary"
          v-if="step > 1"
          @click="step = step - 1"
          >上一步
        </el-button>
        <el-button
          size="small"
          type="primary"
          v-if="step < 4"
          @click="submitRuleForm('ruleForm')"
          >下一步
        </el-button>
        <el-button
          size="small"
          type="primary"
          v-if="step === 4"
          @click="submitRuleForm('ruleForm')"
          >保存
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加商户"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="merchantDialogVisible"
    >
      <div class="form-tip mb20">
        使用<span style="font-weigth: bold; font-size: 16px; color: #e50065"
          >ctrl+f</span
        >
        可搜索商户名
      </div>
      <div class="mb20">
        <el-table
          stripe
          border
          height="400"
          ref="addBrandTable"
          @row-click="
            (row, column, e) => tableSelect(row, column, e, 'addBrandTable')
          "
          @selection-change="getMerchantChecked"
          :data="
            departBindingStoreBox.filter(
              (item) =>
                !merchantName ||
                item.storeName
                  .toLowerCase()
                  .includes(merchantName.toLowerCase())
            )
          "
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商户"
            prop="storeName"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-center">
        <el-button size="small" type="primary" @click="addShop"
          >确 定
        </el-button>
        <el-button size="small" @click="merchantDialogVisible = false"
          >取 消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加商品"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoods"
    >
      <div class="table-panel flex flex-end">
        <div>
          <el-input
            clearable
            style="width: 200px"
            v-model.trim="searchDialogCondition.keyWords"
            placeholder="请输入商品名称/条码"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-select
            clearable
            size="small"
            class="mr10"
            filterable
            v-model="searchDialogCondition.hemiaoBrandId"
            placeholder="请选择商品品牌"
          >
            <el-option
              :label="v.brandName"
              :value="v.hemiaoBrandId"
              v-for="(v, i) in hemiaoBrandBoxList"
              :key="i"
            ></el-option>
          </el-select>

          <el-button type="primary" size="small" @click="searchGoods"
            >查询
          </el-button>
          <el-button size="small" type="text" @click="newGood()"
            >新增商品
          </el-button>
        </div>
      </div>
      <!-- <div class="flex flex-start mb10">
        <div>
          添加商品
          <el-input
            clearable
            style="width:200px;"
            v-model.trim="addGood.goodsName"
            placeholder="请输入商品名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-input
            clearable
            style="width:200px;"
            v-model.trim="addGood.goodsBarcode"
            placeholder="请输入商品条码"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-select
            clearable
            size="small"
            class="mr10"
            v-model="addGood.hemiaoBrandId"
            filterable
            placeholder="请选择商品品牌"
          >
            <el-option
              :label="v.brandName"
              :value="v.hemiaoBrandId"
              v-for="(v, i) in hemiaoBrandBoxList"
              :key="i"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            plain
            size="small"
            :disabled="
              addGood.goodsName === '' ||
                addGood.goodsBarcode === '' ||
                addGood.hemiaoBrandId === ''
            "
            @click="addMerchandise"
            >+ 添加</el-button
          >
        </div>
      </div> -->
      <div class="table">
        <el-table
          stripe
          ref="addGoodTable"
          :data="supplierGoodsInfoList.records"
          @row-click="
            (row, column, e) => tableSelect(row, column, e, 'addGoodTable')
          "
          @selection-change="getChecked"
          style="width: 100%"
          id="table"
          size="small"
          border
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="
              (index) => index + (currentMicroPage - 1) * pageMicroSize + 1
            "
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="商品品牌"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="商品条码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="商品添加时间"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="supplierGoodsInfoList.total"
            @current-change="pagingMicro"
            @size-change="handleSizeMicroChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentMicroPage"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <el-button type="primary" size="small" @click="affirm">确认</el-button>
        <el-button size="small" @click="dialogVisibleGoods = false"
          >取消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="活动详情"
      width="80%"
      :close-on-click-modal="false"
      :visible.sync="detailsDialogVisible"
    >
      <div class="flex flex-between mb10">
        <div class="flex-1">
          活动名称：{{ detailsSupplierBasicInfo.ruleInfo.rewardName }}
        </div>
        <div class="flex-1">
          活动下线：到期<span class="blue">{{
            detailsSupplierBasicInfo.ruleInfo.autoOfflineDaysLimt
          }}</span
          >天后自动下线
        </div>
        <div class="flex-1 flex flex-wrap">
          <div>适用时段：</div>

          <div
            class="flex flex-center blue"
            v-if="
              detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'general'
            "
          >
            {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
              detailsSupplierBasicInfo.ruleInfo.rewardEndDate
            }}
          </div>
          <div
            class="flex flex-center blue"
            v-if="
              detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'special'
            "
          >
            <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'date'">
              {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                detailsSupplierBasicInfo.ruleInfo.rewardEndDate
              }}的每{{ detailsSupplierBasicInfo.ruleInfo.dateValue }}天
            </div>
            <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'week'">
              {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                detailsSupplierBasicInfo.ruleInfo.rewardEndDate
              }}的
              <span
                v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.dateValue"
                :key="i"
              >
                {{ i === 0 ? "" : "," }}每周{{ v }}</span
              >
            </div>
            <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'month'">
              {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                detailsSupplierBasicInfo.ruleInfo.rewardEndDate
              }}的
              <span
                v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.dateValue"
                :key="i"
              >
                {{ i === 0 ? "" : "," }}每月{{ v }}号</span
              >
            </div>
          </div>
        </div>
        <!-- <div class="flex-1">
          基础提成：
          <span
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
            class="primary"
          >
            ¥{{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}</span
          >
          <span v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'">
            {{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}%</span
          >
        </div>
        <div class="flex-1">
          活动条件：参与该活动的商品每满
          <span class="blue">{{
            detailsSupplierBasicInfo.ruleInfo.rewardNumberLimit
          }}</span>
          件为一组计算活动
        </div> -->
      </div>
      <div class="flex flex-between mb10">
        <div class="flex-1">
          适配组织：{{ detailsSupplierBasicInfo.ruleInfo.departNames }}
        </div>
        <div class="flex-1 flex-wrap">
          活动备注：{{ detailsSupplierBasicInfo.ruleInfo.rewardRemark }}
        </div>
      </div>

      <div class="title mb10">
        适用商户:
        <span
          class="blue"
          v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.applyStoreCodes"
          :key="i"
        >
          {{ i === 0 ? "" : "," }}{{ v }}</span
        >
      </div>

      <div class="title mb10">
        适配商户类型：{{
          detailsSupplierBasicInfo.ruleInfo.adapterStoreType == "month"
            ? "月结"
            : "普通"
        }}
      </div>
      <!-- <div class="table mb10">
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.applyStoreCodes"
          style="width: 100%"
          id="table"
          size="small"
          border
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="label"
            label="商户名称"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </div> -->
      <div
        class="title mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
      >
        活动类型：普通活动
      </div>
      <div
        class="title mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
      >
        活动类型：差异活动
      </div>
      <div
        class="title mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
      >
        活动类型：冲刺活动
      </div>
      <div class="title mb10">活动规则：</div>
      <div
        class="table mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
      >
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
          style="width: 500px"
          border
          id="table"
          size="small"
          max-height="500px"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="每组件数"
            prop="rewardNumberLimit"
          >
            <template slot-scope="scope">
              每满{{ scope.row.rewardNumberLimit }}件为一组
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="每组额外奖励"
            prop="rewardValue"
          >
            <template slot-scope="scope">
              {{ scope.row.rewardValue }}元
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="table mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
      >
        <el-table
          :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
          style="width: 100%"
          ref="table"
          stripe
          size="small"
          :show-header="showHeader"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="start"
            label="每组件数"
            width="700"
            prop="rewardNumberLimit"
          >
            <template slot-scope="scope">
              买
              {{ scope.row.rewardNumberLimit }}
              件, 送
              {{ scope.row.rewardSubNum }}
              件,{{
                new Number(scope.row.rewardNumberLimit) +
                new Number(scope.row.rewardSubNum)
              }}件为一组，发放
              {{ scope.row.rewardNumberLimit }}件商品的单件奖励, 每组额外奖励
              {{ scope.row.rewardValue }}
              元
            </template>
          </el-table-column>

          <!-- <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-if="scope.$index === 0"
                      size="small"
                      @click="addChild(scope.$index)"
                      type="text"
                      >新 增</el-button
                    >
                    <el-button
                      v-else
                      size="small"
                      @click="delRule(scope.$index)"
                      class="danger"
                      type="text"
                      >删 除</el-button
                    >
                  </div>
                </template>
              </el-table-column> -->
        </el-table>
      </div>
      <div
        class="table mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
      >
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
          style="width: 500px"
          border
          id="table"
          size="small"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="冲刺门槛"
            prop="rewardNumberLimit"
          >
            <template slot-scope="scope">
              {{ scope.row.rewardNumberLimit }}件
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="额外奖励"
            prop="rewardValue"
          >
            <template slot-scope="scope">
              每件额外奖励{{ scope.row.rewardValue }}元
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="title mb10">适用商品</div>
      <div class="table mb10">
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.goodsList"
          style="width: 100%"
          id="table"
          size="small"
          max-height="500px"
          border
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="商品品牌"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="商品条码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rewardBaseMoney"
            label="单件奖励"
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="detailsDialogVisible = false"
          >确认
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加商品"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGood"
      custom-class="sales-volumn-dialog"
    >
      <el-form
        ref="ruleFormGood"
        :model="ruleFormGood"
        :rules="rulesGood"
        label-width="100px"
      >
        <el-form-item label="商品名称" prop="goodsName">
          <el-input
            clearable
            v-model.trim="ruleFormGood.goodsName"
            maxlength="30"
            size="small"
            placeholder="请输入商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品条码" prop="goodsBarcode">
          <el-input
            clearable
            v-model.trim="ruleFormGood.goodsBarcode"
            maxlength="33"
            size="small"
            placeholder="请输入商品条码"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品品牌" prop="hemiaoBrandId">
          <el-select
            clearable
            size="small"
            class="mr10"
            v-model="ruleFormGood.hemiaoBrandId"
            filterable
            placeholder="请选择商品品牌"
          >
            <el-option
              :label="v.brandName"
              :value="v.hemiaoBrandId"
              v-for="(v, i) in hemiaoBrandBoxList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm('ruleFormGood')"
          >确 定
        </el-button>
        <el-button size="small" @click="dialogVisibleGood = false"
          >取 消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errInputResult.length }}</span
            >条数据导入失败
          </div>
          <!-- <div>
            您有
            <span class="success"> {{ succInputResult.length }}</span
            >条数据导入成功！
          </div> -->
        </div>
        <el-table
          :data="errInputResult"
          border
          class="small-table"
          max-height="400px"
        >
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="错误商品条码"
          >
            <!-- <template slot-scope="scope"
              >{{ scope.row }}
            </template> -->
          </el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号"></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="errValidStore">
      <div slot="title">
        导入失败提示
        <span class="danger"
          >商户名有误、商户名重复或者商户名不属于对应供应商会导致导入失败</span
        >
      </div>
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errStoreResult.length }}</span
            >条数据导入失败
          </div>
          <!-- <div>
            您有
            <span class="success"> {{ succInputResult.length }}</span
            >条数据导入成功！
          </div> -->
        </div>
        <el-table
          :data="errStoreResult"
          border
          class="small-table"
          max-height="500px"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户名称"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      title="操作日志"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleLog"
      custom-class="sales-volumn-dialog"
    >
      <div class="mb10">
        <span class="blue"> {{ row.rewardName }}</span
        >活动
      </div>
      <el-table
        :data="logList"
        style="width: 100%"
        ref="goods"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPageLog - 1) * pageSizeLog + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作人"
          prop="operatorName"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作时间"
          prop="operatorTime"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作行为"
          prop="operatorAction"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.operatorAction === 'yes'">上线</div>
            <div v-if="scope.row.operatorAction === 'no'">下线</div>
            <div v-if="scope.row.operatorAction === 'create'">创建</div>
            <div v-if="scope.row.operatorAction === 'delete'">删除</div>
            <div v-if="scope.row.operatorAction === 'changeDate'">
              修改奖励时段
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalLog"
          @current-change="pagingLog"
          @size-change="handleSizeChangeLog"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPageLog"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      title="修改结束时段"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleTime"
      custom-class="sales-volumn-dialog"
    >
      <div v-if="editTimeShow">
        奖励时段：
        <el-date-picker
          size="small"
          v-model="ruleDate"
          ref="datepicker"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div v-else>
        结束时间：
        <el-date-picker
          v-model="endTime"
          type="date"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          placeholder="结束时间"
          size="small"
          class="mr10"
        >
        </el-date-picker>
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
        <el-button size="small" @click="dialogVisibleTime = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="批量修改结束时段"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleTimeBatch"
      custom-class="sales-volumn-dialog"
    >
      <!-- <div v-if="editTimeShow">
        奖励时段：
        <el-date-picker
          size="small"
          v-model="batchCondition.ruleDate"
          ref="datepicker"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div> -->
      <div>
        结束时间：
        <el-date-picker
          v-model="batchCondition.endTime"
          type="date"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          placeholder="结束时间"
          size="small"
          class="mr10"
        >
        </el-date-picker>
      </div>
      <div class="mt20">
        活动下线: 到期增加<el-input
          type="text"
          maxlength="8"
          @input="filterGt0OrFixed00('addDays')"
          @mousewheel.prevent.native
          style="width: 100px"
          v-model.trim="batchCondition.addDays"
          clearable
          placeholder=""
          size="small"
        ></el-input>
        <span> 天后自动下线。</span>
        <div class="form-item-tip" style="margin-left: 65px">
          只能增多天数，不能减少天数
        </div>
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button size="small" type="primary" @click="batchSetting"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisibleTimeBatch = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="编辑"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :visible.sync="dialogVisibleEdit"
      custom-class="sales-volumn-dialog"
      width="1000px"
    >
      <el-form
        ref="ruleFormEdit"
        :model="ruleFormEdit"
        :rules="rulesEdit"
        label-width="100px"
      >
        <el-form-item label="活动名称:">
          <div
            class="mr20"
            style="padding-left: 20px; width: 260px"
            @dblclick="changeEnddate()"
          >
            <span v-show="edit_enddate">{{ row.rewardName }}</span>
            <el-input
              :ref="'enddateinput'"
              @blur="enddateblur()"
              @keyup.enter.native="$event.target.blur"
              clearable
              v-show="!edit_enddate"
              size="small"
              style="width: 260px"
              v-model="row.rewardName"
              placeholder="请输入活动名称"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="活动下线:" prop="autoOfflineDaysLimt">
          到期
          <!-- <el-input-number
            style="width:220px"
            v-model="ruleFormEdit.autoOfflineDaysLimt"
            controls-position="right"
            :min="numLimt"
          ></el-input-number> -->
          <el-input
            type="text"
            maxlength="8"
            @input="filterGt0OrFixed0('autoOfflineDaysLimt')"
            @mousewheel.prevent.native
            style="width: 100px"
            v-model.trim="ruleFormEdit.autoOfflineDaysLimt"
            clearable
            placeholder=""
            size="small"
          ></el-input>
          <span> 天后自动下线。</span>
          <div class="form-item-tip">只能增多天数，不能减少天数</div>
        </el-form-item>
        <el-form-item label="添加商户:" prop="value">
          <div class="mb10">
            适配组织机构：{{ applDepartNames }}
            <!-- <el-cascader
              clearable
              filterable
              style="width:600px"
              class="mr10 applDepart"
              ref="cascader"
              v-model="ruleFormEdit.applDepartId"
              :props="props"
              :show-all-levels="false"
              size="small"
              placeholder="请选择机构"
            ></el-cascader> -->
          </div>
          <div class="flex flex-between mb10">
            <div>
              添加商户：
              <el-button
                type="primary"
                plain
                size="small"
                :disabled="!applDepartNames"
                @click="merchantDialogVisible = true"
                >+ 添加商户
              </el-button>
            </div>
            <div>
              <el-button @click="output" type="primary" size="small"
                >导出模板
              </el-button>
              <el-button type="primary" size="small" class="open-file pointer"
                >导入表格
                <input
                  type="file"
                  class="pointer"
                  @change="importfs"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </el-button>
            </div>
          </div>
          <div class="table mb10">
            <el-table
              stripe
              ref="roleTable"
              :data="shopList"
              style="width: 100%"
              id="table"
              size="small"
              border
              max-height="400"
            >
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="商户名称"
              ></el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="创建时间"
              ></el-table-column> -->
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-tooltip
                      class="item"
                      content="删除"
                      placement="top"
                      v-if="scope.row.delFlag !== '0'"
                    >
                      <div class="pointer mr10" @click="remove(scope.row)">
                        <span class="hmicon icon-shanchu primary"></span>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="添加商品:" prop="">
          <div class="flex flex-between item-center mb10">
            <div>
              <el-button type="primary" plain size="small" @click="editAddGoods"
                >+ 添加商品
              </el-button>
            </div>
            <div class="flex item-center">
              <el-button @click="outputExcel" type="primary" size="small"
                >导出模板
              </el-button>
              <el-button type="primary" size="small" class="open-file pointer"
                >导入表格
                <input
                  type="file"
                  class="pointer"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </el-button>
            </div>
          </div>
          <div class="table mb10">
            <el-table
              stripe
              ref="roleTable"
              :data="addGoodsList"
              style="width: 100%"
              id="table"
              size="small"
              border
              max-height="400"
            >
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="brandName"
                label="商品品牌"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品名称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsBarcode"
                label="商品条码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="rewardBaseMoney"
                label="单件奖励"
                v-if="row.rewardMode === 'sub'"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.delFlag == '0'">{{
                    scope.row.rewardBaseMoney
                  }}</span>
                  <el-input
                    type="text"
                    maxlength="8"
                    @input="
                      filterGt0OrGoodsListFixed2(
                        scope.$index,
                        'rewardBaseMoney'
                      )
                    "
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardBaseMoney"
                    clearable
                    placeholder=""
                    size="small"
                    v-else
                  ></el-input>

                  元
                </template>
              </el-table-column>

              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-tooltip
                      class="item"
                      content="删除"
                      placement="top"
                      v-if="scope.row.delFlag !== '0'"
                    >
                      <div class="pointer mr10" @click="removeGoods(scope.row)">
                        <span class="hmicon icon-shanchu primary"></span>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="submitEdit('ruleFormEdit')"
          >确 定</el-button
        >
        <el-button size="small" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="1000px"
      :close-on-click-modal="false"
      :visible.sync="repeatGoodsDialogVisible"
    >
      <div slot="title">
        提示： <span class="primary"> 以下商品已参与同时段其他活动</span>
      </div>
      <div class="table">
        <el-table
          :data="repeatGoodsList"
          stripe
          border
          size="small"
          class="small-table"
          max-height="500px"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="商品条码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rewardName"
            label="已参加活动名称"
          >
            <template slot-scope="scope">
              <div>
                <el-button
                  v-for="(v, i) in scope.row.repeatRewardInfo"
                  :key="i"
                  type="text"
                  size="small"
                  class="blue"
                  @click="toDetails(v)"
                >
                  {{ v.rewardName }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <!-- <el-button
                  type="text"
                  size="small"
                  @click="toDetails(scope.row)"
                  >活动详情</el-button
                > -->
                <el-button
                  type="text"
                  size="small"
                  @click="importfGoods(scope.row, scope.$index)"
                  >导入
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="flex flex-center">
        <el-button size="small" type="primary" @click="allImportfGoods"
          >全部继续添加
        </el-button>
        <el-button size="small" @click="delectImportfGoods"
          >全部不添加到活动
        </el-button>
        <el-button size="small" @click="repeatGoodsDialogVisible = false"
          >取 消
        </el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import moment from "moment";
import HmStep from "@/components/HmStep";
import HmDateSelect from "@/components/HmDateSelect";
import { mapGetters } from "vuex";
import {
  arrayUnique2,
  isRepeat,
  compareDate,
  getSubtract,
  getRemove,
  setCookie,
  getCookie,
} from "@/utils/utils";
// import XLSX from "xlsx";
import * as XLSX from "xlsx/xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: { HmStep, HmDateSelect },
  data() {
    const autoOfflineDaysLimtFunc = (rule, val, callback) => {
      if (new Number(val) < new Number(this.numLimt)) {
        return callback(new Error("到期天数不能小于" + this.numLimt + "天"));
      }
      callback();
    };
    const validatorRewardFunc = (rule, val, callback) => {
      if (this.ruleForm.rewardMode === "sub") {
        if (val.length > 0) {
          let flag = false;
          val.forEach((v) => {
            if (v.rewardNumberLimit === "" || v.rewardValue === "") {
              flag = true;
            }
          });
          if (flag) {
            return callback(new Error("请填写完整规则！"));
          }
        }
      } else {
        if (val.length === 0) {
          return callback(new Error("请添加活动规则"));
        } else {
          let flag = false;
          val.forEach((v) => {
            if (v.rewardNumberLimit === "" || v.rewardValue === "") {
              flag = true;
            }
          });
          if (flag) {
            return callback(new Error("请填写完整规则！"));
          }
          let ary = val.map((o) => o.rewardNumberLimit);
          if (isRepeat(ary)) {
            return callback(new Error("相同件数不允许重复！"));
          }
        }
      }

      callback();
    };
    const validatorFunc = (rule, val, callback) => {
      const {
        runningTimeType,
        ruleDateAndTime,
        ruleDate,
        dateType,
        dateValue,
        dateConfigRange,
        week,
        daysList,
      } = this.$refs.hmDateSelect;
      // 选择全时段
      if (runningTimeType === "all") {
        if ((ruleDateAndTime && !ruleDateAndTime[0]) || !ruleDateAndTime) {
          return callback(new Error("请选择日期"));
        }
        callback();
        // 选择特定时段
      } else if (runningTimeType === "special") {
        if (dateConfigRange && !dateConfigRange.length) {
          return callback(new Error("请选择促销时间"));
        } else if ((ruleDate && !ruleDate.length) || !ruleDate) {
          return callback(new Error("请选择促销日期"));
        }
        if (dateType === "day") {
          if (!dateValue) {
            return callback(new Error("请输入促销天数"));
          } else callback();
        } else if (dateType === "week") {
          if (week && !week.length) {
            return callback(new Error("请选择促销周"));
          }
          callback();
        } else if (dateType === "month") {
          if (daysList && !daysList.length) {
            return callback(new Error("请选择促销天"));
          }
          callback();
        }
      }
    };
    // const typeFunc = function(rule, val, callback) {
    //   if (val === "fixed") {
    //     if (this.ruleForm.rewardValue === "") {
    //       return callback(new Error("请输入缴费金额"));
    //     }
    //   } else if (val === "radio") {
    //     if (this.ruleForm.rewardValue === "") {
    //       return callback(new Error("请输入缴费比例"));
    //     } else {
    //       if (this.ruleForm.rewardValue > 100) {
    //         return callback(new Error("缴费比例不能超过100%"));
    //       }
    //     }
    //   }

    //   callback();
    // }.bind(this);
    return {
      repeatGoodsList: [],
      repeatGoodsDialogVisible: false,
      errValidStore: false,
      errStoreResult: [],
      checkedRowList: [],
      checkedMerchantRow: [],
      numLimt: 0,
      ruleFormEdit: {
        autoOfflineDaysLimt: "",
        applDepartId: [],
      },
      rulesEdit: {
        autoOfflineDaysLimt: [
          {
            required: true,
            message: "请输入到期天数",
            trigger: "change",
          },
          {
            required: true,
            pattern: /^([1-9]\d*|[0]{1,1})$/,
            message: "请输入正整数",
            trigger: "change",
          },
          {
            required: true,
            validator: autoOfflineDaysLimtFunc,
            trigger: "blur",
          },
        ],
      },
      dialogVisibleEdit: false,
      ruleDate: [],
      showHeader: false,
      dialogVisibleTime: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < moment().subtract(1, "days");
        },
      },
      endTime: "",
      currentPageLog: 1,
      pageSizeLog: 10,
      totalLog: 0,
      dialogVisibleLog: false,
      ruleRelModelList: [],
      succInputResult: [],
      errInputResult: [],
      errValidGoods: false,
      dialogVisibleGood: false,
      ruleFormGood: {
        goodsName: "",
        goodsBarcode: "",
        hemiaoBrandId: "",
      },
      rulesGood: {
        goodsName: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
          {
            required: true,
            max: 30,
            message: "名称应大于30个字",
            trigger: "blur",
          },
        ],
        goodsBarcode: [
          {
            required: true,
            message: "请输入商品条码",
            trigger: "blur",
          },
        ],
        hemiaoBrandId: [
          {
            required: true,
            message: "请选择商品品牌",
            trigger: "blur",
          },
        ],
      },
      detailsDialogVisible: false,
      cascaderList: [],
      isShow: false,
      datePicker: true,
      props: {
        lazy: true,
        multiple: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationList", {
                pageNo: 1,
                pageSize: 999,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                res.result.records.forEach((v) => {
                  v.leaf = Boolean(!v.isParent);
                  v.all = {
                    label: v.departName,
                    value: v.id || v.treeStruct,
                  };
                  v.value = v.all;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryListOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = Boolean(!v.isParent);
                    // v.value = v.id;
                    // v.label = v.departName;
                    v.all = {
                      label: v.departName,
                      value: v.id || v.treeStruct,
                    };
                    v.value = v.all;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      propss: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationList", {
                pageNo: 1,
                pageSize: 999,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                res.result.records.forEach((v) => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.id;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryListOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.id;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      searchCondition: {
        applyDepartIds: [],
        queryType: "goodsName",
      },
      currentPage: 1,
      pageSize: 10,
      storeNames: "",
      addGoodsList: [],
      holdeCheckedMerchantRow: [],
      currentMicroPage: 1,
      pageMicroSize: 10,
      checkedRow: [],
      checkedDelRow: [],
      dialogVisibleGoods: false,
      searchDialogCondition: {},
      addGood: {
        goodsName: "",
        goodsBarcode: "",
        hemiaoBrandId: "",
        storeCode: this.$route.query.storeCode,
      },
      shopList: [],
      options: [],
      value: "",
      list: [],
      loading: false,
      states: [],
      dialogVisible: false,
      merchantDialogVisible: false,
      step: 1,
      merchantName: "",
      disabledFirst: false,
      ruleForm: {
        rewardName: "",
        rewardNumberLimit: "",
        rewardMode: "fixed",
        rewardValue: "",
        applDepartId: [],
        rewardRemark: "",
        autoOfflineDaysLimt: "",
        rewardStartDate: "",
        rewardEndDate: "",
        ruleRelModelList: [
          {
            rewardNumberLimit: "",
            rewardValue: "",
          },
        ],
        adapterStoreType: "norm",
      },
      rules: {
        validatorTime: {
          required: true,
          validator: validatorFunc,
          trigger: "blur",
        },
        rewardName: {
          required: true,
          message: "请输入活动名称",
          trigger: "change",
        },
        ruleRelModelList: [
          {
            required: true,
            validator: validatorRewardFunc,
            trigger: "blur",
          },
        ],
        rewardMode: [
          {
            required: true,
            message: "请选择缴费方式",
            trigger: "blur",
          },
          // {
          //   required: true,
          //   validator: typeFunc,
          //   trigger: "blur"
          // }
        ],
        applDepartId: [
          {
            required: true,
            message: "请选择匹配组织架构",
            trigger: "blur",
          },
        ],
        autoOfflineDaysLimt: {
          required: true,
          message: "请输入活动下线时间",
          trigger: "change",
        },
        adapterStoreType: {
          required: true,
          message: "请选择适配商户类型",
          trigger: "change",
        },
      },
      steps: [
        {
          name: "活动规则",
        },
        {
          name: "适用商户",
        },
        {
          name: "适用商品",
        },
        {
          name: "创建活动",
        },
      ],
      type: "",
      flag: false,
      row: {},
      logList: [],
      editTimeShow: false,
      autoOfflineDaysLimt: "",
      applDepartNames: "",
      checkedShopRowList: [],
      shopSearchVal: "",
      goodSearchVal: "",
      edit_enddate: true,
      editwxName: "",
      selectActivityIndex: null,
      storeBasicInfoListBoxList: [],
      batchCondition: {
        ruleDate: "",
        endTime: "",
      },
      dialogVisibleTimeBatch: false,
      edit_rewardName: true,
      editrewardName: "",
    };
  },
  computed: mapGetters([
    "supplierRewardRuleInfoList",
    "storeBasicInfoListBox",
    "departBindingStoreBox",
    "supplierGoodsInfoList",
    "hemiaoBrandBoxList",
    "detailsSupplierBasicInfo",
  ]),
  watch: {},
  created() {},
  mounted() {
    this.storeNames = localStorage.getItem("storeName");
    this.getParamsCookie();
    this.queryList();
    this.$store.dispatch("queryStoreBasicInfoListBox", {
      supplierCode: this.$route.query.storeCode,
    });
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        this.storeBasicInfoListBoxList = this.storeBasicInfoListBox.filter(
          (v) => v.storeName.indexOf(query) > -1
        );
      } else {
        this.storeBasicInfoListBoxList = [];
      }
    },
    tableRowClassName({ row, rowIndex }) {
      // console.log("rowIndex", rowIndex);
      // console.log("selectActivityIndex", this.selectActivityIndex);
      if (rowIndex == this.selectActivityIndex) {
        return "activity-style";
      } else {
        return "";
      }
    },
    changeEnddate() {
      this.editwxName = this.row.rewardName;
      this.edit_enddate = !this.edit_enddate; //直接加key
      // this.list = [...this.list];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs.enddateinput.focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    enddateblur() {
      if (
        this.row.rewardName === "" ||
        this.row.rewardName === this.editwxName
      ) {
        this.row.rewardName = this.editwxName;
      }
      this.edit_enddate = !this.edit_enddate;
    },
    changeRewardName() {
      this.editrewardName = this.ruleForm.rewardName;
      this.edit_rewardName = !this.edit_rewardName; //直接加key
      // this.list = [...this.list];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs.rewardNameinput.focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    rewardNameblur() {
      if (
        this.ruleForm.rewardName === "" ||
        this.ruleForm.rewardName === this.editrewardName
      ) {
        this.ruleForm.rewardName = this.editrewardName;
      }
      this.edit_rewardName = !this.edit_rewardName;
    },
    tableSelect(row, column, event, tableName) {
      if (column.label != "操作" && column.label != "单件奖励") {
        this.$refs[tableName].toggleRowSelection(row);
      }
    },
    getShopBatchChecked(selection) {
      this.checkedShopRowList = selection;
    },
    batchRemoveShops() {
      if (this.checkedShopRowList.length) {
        this.shopList = getSubtract(
          this.shopList,
          this.checkedShopRowList,
          "storeCode"
        );
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    batchRemove() {
      if (this.checkedRowList.length) {
        this.addGoodsList = getSubtract(
          this.addGoodsList,
          this.checkedRowList,
          "supplierGoodsId"
        );
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    getBatchChecked(selection) {
      this.checkedRowList = selection;
    },
    addChildSub() {
      this.ruleForm.ruleRelModelList.push({
        rewardNumberLimit: "",
        rewardValue: "",
        rewardSubNum: "",
      });
    },
    rewardModeChange(val) {
      if (val === "sub") {
        this.ruleForm.ruleRelModelList = [];
      } else {
        this.ruleForm.ruleRelModelList = [
          {
            rewardNumberLimit: "",
            rewardValue: "",
          },
        ];
      }
    },
    async submit() {
      if (this.editTimeShow) {
        if (this.ruleDate.length) {
          let params = {
            rewardRuleId: this.row.rewardRuleId,
            rewardStartDate: this.ruleDate[0],
            rewardEndDate: this.ruleDate[1],
          };
          const { code } = await this.$store.dispatch(
            "editRewardRuleEndDate",
            params
          );
          if (code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.dialogVisibleTime = false;
            this.queryList();
          }
        } else {
          this.$message({
            message: "请选择时段！",
            type: "warning",
          });
        }
      } else {
        if (this.endTime !== "") {
          let params = {
            rewardRuleId: this.row.rewardRuleId,
            rewardEndDate: this.endTime,
          };
          const { code } = await this.$store.dispatch(
            "editRewardRuleEndDate",
            params
          );
          if (code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.dialogVisibleTime = false;
            this.queryList();
          }
        } else {
          this.$message({
            message: "请选择结束时间！",
            type: "warning",
          });
        }
      }
    },
    editTime(row) {
      this.row = row;
      let mydate = moment().format("YYYY/MM/DD");
      this.editTimeShow = compareDate(
        row.timeFormatValue.split("至")[0],
        mydate.replace(/\//g, "-")
      );
      // if (this.editTimeShow) {
      //   this.ruleDate = [
      //     row.timeFormatValue.split("至")[0],
      //     row.timeFormatValue.split("至")[1]
      //   ];
      // } else {
      //   this.endTime = row.timeFormatValue.split("至")[1];
      // }
      this.dialogVisibleTime = true;
    },
    addChild() {
      this.ruleForm.ruleRelModelList.push({
        rewardNumberLimit: "",
        rewardValue: "",
      });
      // this.flag = false;
      // this.ruleForm.ruleRelModelList.forEach(v => {
      //   if (v.rewardNumberLimit === this.ruleForm.rewardNumberLimit) {
      //     this.flag = true;
      //   }
      // });
      // if (!this.flag) {
      //   this.ruleForm.ruleRelModelList.push({
      //     rewardNumberLimit: this.ruleForm.rewardNumberLimit,
      //     rewardValue: this.ruleForm.rewardValue
      //   });
      // }
    },
    delRule(index) {
      this.ruleForm.ruleRelModelList.splice(index, 1);
    },
    importfs(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        // let importfList = [];
        that.errStoreResult = [];
        result.forEach((v) => {
          if (v[0]) {
            formatResult.push({
              storeName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
            });
          }
        });

        formatResult.forEach((v) => {
          let i = that.departBindingStoreBox.findIndex(
            (o) => o.storeName === v.storeName
          );

          if (i > -1) {
            that.shopList.push(that.departBindingStoreBox[i]);
          } else {
            that.errStoreResult.push(v);
          }
          // if (
          //   that.departBindingStoreBox.findIndex(
          //     o => o.storeName === v.storeName
          //   ) < 0
          // ) {
          //   errList.push(v);
          // }

          // that.departBindingStoreBox.forEach(o => {
          //   if (o.storeName === v.storeName) {
          //     that.shopList.push(o);
          //   }
          // });
        });
        if (that.errStoreResult.length) {
          that.errValidStore = true;
        }
        that.shopList = arrayUnique2(that.shopList, "storeName");
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    async supplierGoodsInfoCheckGoods(checkGoodsList) {
      console.log(this.ruleForm);
      let params = {
        supplierGoodsIdList: checkGoodsList.map((v) => v.supplierGoodsId),
        applyStoreCodes: this.shopList.map((v) => v.storeCode),
        rewardStartDate: this.ruleForm.rewardStartDate,
        rewardEndDate: this.ruleForm.rewardEndDate,
      };
      const { result } = await this.$store.dispatch(
        "supplierGoodsInfoCheckGoods",
        params
      );
      if (result.length) {
        let goodsList = [];
        this.repeatGoodsDialogVisible = true;
        checkGoodsList.forEach((v) => {
          result.forEach((o) => {
            if (o.goodsBarcode === v.goodsBarcode) {
              goodsList.push(Object.assign({}, o, v));
            }
          });
        });
        this.repeatGoodsList = goodsList;
      }
      let acnm = arrayUnique2(result, "supplierGoodsId");
      let subList = getSubtract(checkGoodsList, acnm, "supplierGoodsId");

      this.addGoodsList.push(...subList);
      this.addGoodsList = arrayUnique2(this.addGoodsList, "supplierGoodsId");
    },
    importfGoods(row, i) {
      this.addGoodsList.unshift(row);
      this.addGoodsList = arrayUnique2(this.addGoodsList, "supplierGoodsId");
      this.repeatGoodsList.splice(i, 1);
    },
    allImportfGoods() {
      this.addGoodsList.unshift(...this.repeatGoodsList);
      this.addGoodsList = arrayUnique2(this.addGoodsList, "supplierGoodsId");
      this.repeatGoodsList = [];
      this.repeatGoodsDialogVisible = false;
    },
    delectImportfGoods() {
      this.addGoodsList.forEach((v) => {
        this.repeatGoodsList.forEach((o) => {
          if (v.supplierGoodsId === o.supplierGoodsId) {
            v.repeat = true;
          }
        });
      });
      this.addGoodsList = this.addGoodsList.filter((item) => !item.repeat);
      this.repeatGoodsList = [];
      this.repeatGoodsDialogVisible = false;
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        let importfList = [];
        result.forEach((v) => {
          if (v[0]) {
            formatResult.push({
              goodsBarcode: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              storeCode: that.$route.query.storeCode,
            });
            if (that.ruleForm.rewardMode === "sub") {
              importfList.push({
                goodsBarcode: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
                rewardBaseMoney: v[1] ? +v[1] : "",
              });
            }
          }
        });

        that.$store
          .dispatch("exportRewardGoodsSupplier", formatResult)
          .then((res) => {
            const { code, result } = res;
            if (code === "0") {
              const { failList, successList } = result;

              if (failList.length) {
                setTimeout(() => {
                  that.errValidGoods = true;
                }, 100);
                that.errInputResult = failList;
                that.$message({
                  message: "部分条码导入失败！",
                  type: "warning",
                });
              }
              that.succInputResult = successList;

              let goodsList = [];
              // let repeatgoodsList = [];
              console.log(
                "that.ruleForm.rewardMode: ",
                that.ruleForm.rewardMode
              );
              if (that.ruleForm.rewardMode === "sub") {
                importfList.forEach((v) => {
                  v.rewardBaseMoney = v.rewardBaseMoney
                    ? v.rewardBaseMoney.toFixed(2)
                    : "";
                });
                successList.forEach((v) => {
                  importfList.forEach((o) => {
                    if (o.goodsBarcode === v.goodsBarcode) {
                      goodsList.push(Object.assign({}, o, v));
                    }
                  });
                });
              } else {
                goodsList = successList;
              }
              // if (repeatRewardList.length) {
              //   that.repeatGoodsDialogVisible = true;
              //   repeatRewardList.forEach(v => {
              //     importfList.forEach(o => {
              //       if (o.goodsBarcode === v.goodsBarcode) {
              //         repeatgoodsList.push(Object.assign({}, o, v));
              //       }
              //     });
              //   });
              //   console.log("repeatgoodsList: ", repeatgoodsList);
              //   that.repeatGoodsList = repeatgoodsList;
              // }
              that.supplierGoodsInfoCheckGoods(goodsList);
              // that.addGoodsList = that.addGoodsList.concat(goodsList);

              // that.addGoodsList = arrayUnique2(
              //   that.addGoodsList,
              //   "supplierGoodsId"
              // );

              that.$forceUpdate();
            }
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商户名称"];
        const data = [];
        exportJsonToExcel(tHeader, data, "导入商户模板");
      });
    },
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");

        const tHeader =
          this.ruleForm.rewardMode === "sub"
            ? ["商品条码(单次最多导入200条)", "单件奖励"]
            : ["商品条码(单次最多导入200条)"];
        const data = [];
        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    changgeaa() {
      this.type = "add";
      if (this.type === "add") {
        this.value = [];
        this.shopList = [];
        this.ruleForm.applyDepartNames = [];
        this.ruleForm.applyDepartIds = [];
        this.ruleForm.applDepartId.forEach((v) => {
          this.ruleForm.applyDepartIds.push(v[v.length - 1].value);
          this.ruleForm.applyDepartNames.push(v[v.length - 1].label);
        });
      }
      if (this.ruleForm.applyDepartIds.length) {
        this.queryStoreBoxList();
      }
    },
    filterGt0OrFixed0(prop) {
      if (prop !== "autoOfflineDaysLimt") {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      }

      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d]/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    filterGt0OrFixed00(prop) {
      if (prop === "addDays") {
        this.batchCondition[prop] = this.batchCondition[prop].replace(
          /^(0+)/,
          ""
        ); //过滤0开头
      }

      this.batchCondition[prop] = this.batchCondition[prop].replace(
        /[^\d]/g,
        ""
      );
      this.batchCondition[prop] = this.batchCondition[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    selectAll() {
      if (this.value.length < this.departBindingStoreBox.length) {
        this.value = [];
        this.departBindingStoreBox.map((item) => {
          this.value.push(`${item.storeName},${item.storeCode}`);
        });
        this.value.unshift("all");
      } else {
        this.value = [];
      }
    },
    changeSelect(val) {
      if (
        !val.includes("all") &&
        val.length === this.departBindingStoreBox.length
      ) {
        this.value.unshift("all");
      } else if (
        val.includes("all") &&
        val.length - 1 < this.departBindingStoreBox.length
      ) {
        this.value = this.value.filter((item) => {
          return item !== "all";
        });
      }
    },
    removeTag(val) {
      if (val === "all") {
        this.value = [];
      }
    },
    del(row) {
      this.$confirm(" 是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        let params = {
          rewardRuleIds: [row.rewardRuleId],
          supplierCode: this.$route.query.storeCode,
        };
        this.$store
          .dispatch("delSupplierRewardRuleInfoList", params)
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success",
              });
              this.queryList();
            }
          });
      });
    },
    async operationLog(row, index) {
      this.selectActivityIndex = index;
      this.dialogVisibleLog = true;
      this.row = row;
      this.pageSizeLog = 10;
      this.currentPageLog = 1;
      this.queryLogList();
    },
    async queryLogList() {
      let params = {
        pageSize: this.pageSizeLog,
        pageNo: this.currentPageLog,
        bizDataPk: this.row.rewardRuleId,
        bizType: "redMoneyReward",
      };
      const { result } = await this.$store.dispatch(
        "storeOperationLogList",
        params
      );
      this.logList = result.records;
      this.totalLog = result.total;
    },
    toDetails(row, index) {
      // this.selectActivityIndex = index;
      // this.$store
      //   .dispatch("detailsSupplierRewardRuleInfoList", {
      //     rewardRuleId: row.rewardRuleId,
      //   })
      //   .then(() => {
      //     this.detailsDialogVisible = true;
      //   });
      this.$router.push({
        path: '/guiderCommission/addMatchActivityManagement',
        type: 'add',
        query: {
            storeCode: this.$route.query.storeCode,
            row: JSON.stringify({rewardRuleId: row.rewardRuleId, rewardName: row.rewardName}),
            type: 'detail'
        }
      })
    },
    async edit(row, index, type) {
      this.$router.push({
        path: '/guiderCommission/addMatchActivityManagement',
        type: 'add',
        query: {
            storeCode: this.$route.query.storeCode,
            row: JSON.stringify({rewardRuleId: row.rewardRuleId, rewardName: row.rewardName}),
            type,
            showAudit: true
        }
      })
      // this.$router.push({
      //   path: '/guiderCommission/addMatchActivityManagement',,
      //   type: 'add',
      //   query: {
      //       storeCode: this.$route.query.storeCode,
      //       row: JSON.stringify({rewardRuleId: row.rewardRuleId, rewardName: row.rewardName}),
      //       type,
      //       showAudit: true
      //   }
      // })
      // this.selectActivityIndex = index;
      // this.row = JSON.parse(JSON.stringify(row));
      // this.dialogVisibleEdit = true;
      // const { result } = await this.$store.dispatch(
      //   "copySupplierRewardRuleInfo",
      //   {
      //     rewardRuleId: row.rewardRuleId,
      //   }
      // );
      // this.ruleForm.applyDepartIds = [];
      // this.ruleForm.rewardStartDate = result.rewardStartDate;
      // this.ruleForm.rewardEndDate = result.rewardEndDate;
      // this.ruleForm.rewardMode = result.rewardMode;
      // result.storeDepartInfoModelList.forEach((v) => {
      //   this.ruleForm.applyDepartIds.push(v.id);
      //   // this.ruleForm.applyDepartNames.push(v.departName);
      // });
      // this.applDepartNames = result.storeDepartInfoModelList
      //   .map((o) => o.departName)
      //   .join(",");
      // this.shopList = result.storeBasicInfoModelList;
      // this.addGoodsList = result.ruleGoodsList;
      // this.ruleFormEdit.autoOfflineDaysLimt = JSON.stringify(
      //   JSON.parse(result.autoOfflineDaysLimt)
      // );
      // this.numLimt = JSON.stringify(JSON.parse(result.autoOfflineDaysLimt));
      // this.queryStoreBoxList();
      // this.$forceUpdate();
    },
    async copy(row) {
      this.$router.push({
        path: '/guiderCommission/addMatchActivityManagement',
        query: {
          storeCode: this.$route.query.storeCode,
          rewardRuleId: row.rewardRuleId
        }
      })
    },
    onLine(row, state) {
      let msg = state === "yes" ? "上线?" : "下线?";
      this.$confirm("是否确认" + msg, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        this.editRuleState(row.rewardRuleId, state);
      });
    },
    editRuleState(rewardRuleId, state) {
      let params = {
        rewardRuleId: rewardRuleId,
        enabledState: state,
      };
      return this.$store.dispatch("editRuleState", params).then((res) => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.queryList();
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisibleEdit = false;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    resetRuleForm() {
      this.step = 1;
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
        this.$refs.hmDateSelect.runningTimeType = "";
        this.$refs.hmDateSelect.ruleDateAndTime = "";
        this.$refs.hmDateSelect.ruleDate = [];
        this.$refs.hmDateSelect.dateType = "";
        this.$refs.hmDateSelect.week = [];
        this.$refs.hmDateSelect.daysList = [];
      }
      if (this.$refs.ruleFormEdit) {
        this.$refs.ruleFormEdit.resetFields();
      }
      this.ruleForm.applyDepartIds = [];
      this.applDepartNames = "";
      this.ruleForm.applDepartId = [];
      this.value = "";
      this.shopList = [];
      this.addGood = {};
      this.ruleForm.rewardValue = "";
      this.ruleForm.ruleRelModelList = [
        {
          rewardNumberLimit: "",
          rewardValue: "",
        },
      ];
      this.addGoodsList = [];
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    pagingLog(page) {
      this.currentPageLog = page;
      this.queryLogList();
    },
    handleSizeChangeLog(size) {
      this.currentPageLog = 1;
      this.pageSizeLog = size;
      this.queryLogList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        supplierCode: this.$route.query.storeCode,
        rewardMode: 'collocation'
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition[this.searchCondition.queryType] =
        searchCondition.keyWords;
      if (
        searchCondition.applyDepartIds &&
        searchCondition.applyDepartIds.length > 0
      ) {
        searchCondition.applyDepartId =
          searchCondition.applyDepartIds[
            searchCondition.applyDepartIds.length - 1
          ];
      }
      Object.assign(params, searchCondition);
      this.setParamsCookie();
      return this.$store.dispatch("querySupplierRewardRuleInfoList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "redpackageActivityListParamsNew" + this.$route.query.storeCode,
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "redpackageActivityListParamsNew" + this.$route.query.storeCode,
        type: "session",
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryStoreBoxList(query) {
      let params = {
        applyDepartIds: this.ruleForm.applyDepartIds,
        storeName: query,
        supplierCode: this.$route.query.storeCode,
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      // Object.assign(params, searchCondition);
      return this.$store.dispatch("queryDepartBindingStoreComboBoxNew", params);
    },
    newGood() {
      this.dialogVisibleGood = true;
    },
    addAct() {
    //   this.type = "add";
    //   this.dialogVisible = true;
    console.log('-----add-------');
      this.$router.push({
        path: '/guiderCommission/addMatchActivityManagement',
        type: 'add',
        query: {
            storeCode: this.$route.query.storeCode
        }
      })
    },
    // remoteMethod(query) {

    //   if (query !== "") {
    //     this.loading = true;
    //     // this.queryStoreBoxList(query).then(res=>{
    //     //   if(res.code==="0"){

    //     //     this.options = res.result.filter(item => {
    //     //     return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //     //   });
    //     //   }
    //     // })
    //     setTimeout(() => {
    //       this.loading = false;
    //       this.options = this.list.filter(item => {
    //         return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //       });
    //     }, 200);
    //   } else {
    //     this.options = [];
    //   }
    // },
    submitEdit(formName) {
      // editRewardRuleInfo
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.row.rewardName = this.row.rewardName
            .replace("（", "(")
            .replace("）", ")");
          let params = {
            rewardRuleId: this.row.rewardRuleId,
            rewardName: this.row.rewardName,
            autoOfflineDaysLimt: this.ruleFormEdit.autoOfflineDaysLimt,
            storeBasicInfoModelList: this.shopList,
            ruleGoodsList: this.addGoodsList,
          };
          this.$store.dispatch("editRewardRuleInfo", params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogVisibleEdit = false;
              this.queryList();

              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
            }
          });
        }
      });
    },
    submitRuleForm(formName) {
      if (this.step === 1) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (
              !this.ruleForm.ruleRelModelList ||
              this.ruleForm.ruleRelModelList.length < 1
            ) {
              this.$message({
                message: "请填写活动规则!",
                type: "warning",
              });
              return false;
            }
            const {
              runningTimeType,
              ruleDateAndTime,
              ruleDate,
              dateType,
              dateValue,
              // dateConfigRange,
              week,
              daysList,
            } = this.$refs.hmDateSelect;
            let step1 = {};
            step1.dateConfigMode =
              runningTimeType === "all" ? "general" : "special";
            if (runningTimeType === "all") {
              // 选择全时段
              step1.rewardStartDate = ruleDateAndTime.length
                ? ruleDateAndTime[0]
                : "";
              step1.rewardEndDate = ruleDateAndTime.length
                ? ruleDateAndTime[1]
                : "";
            } else if (runningTimeType === "special") {
              // 选择特定时段
              // step1.dateConfigRange = dateConfigRange.sort(
              //   this.sortTime("promotionStartTime")
              // );
              step1.rewardStartDate = ruleDate[0];
              step1.rewardEndDate = ruleDate[1];
              step1.dateType = dateType === "day" ? "date" : dateType;
              if (dateType === "day") {
                step1.dateValue = dateValue.sort();
              } else if (dateType === "week") {
                step1.dateValue = week.sort();
              } else if (dateType === "month") {
                step1.dateValue = daysList;
              }
            }
            if (this.type === "add") {
              this.ruleForm.applyDepartNames = [];
              this.ruleForm.applyDepartIds = [];
              this.ruleForm.applDepartId.forEach((v) => {
                this.ruleForm.applyDepartIds.push(v[v.length - 1].value);
                this.ruleForm.applyDepartNames.push(v[v.length - 1].label);
              });
            }
            this.ruleForm.ruleRelModelList.forEach((v) => {
              v.rewardNumberLimit = new Number(v.rewardNumberLimit);
              if (this.ruleForm.rewardMode === "sub") {
                v.rewardSubNum = new Number(v.rewardSubNum);
              }
            });
            this.ruleForm.autoOfflineDaysLimt = new Number(
              this.ruleForm.autoOfflineDaysLimt
            );
            Object.assign(this.ruleForm, step1);
            this.step = this.step + 1;
          } else {
            return false;
          }
        });
      } else if (this.step === 2) {
        if (this.shopList.length > 0) {
          this.step = this.step + 1;
          this.queryMicroShopGoodsList();
          if (this.type == "copy") {
            this.supplierGoodsInfoCheckGoods(this.addGoodsList);
          }
        } else {
          this.$message({
            message: "请添加商户!",
            type: "warning",
          });
        }
      } else if (this.step === 3) {
        console.log("goods", this.addGoodsList);
        if (this.addGoodsList.length > 0) {
          let flag = false;
          if (this.ruleForm.rewardMode === "sub") {
            this.addGoodsList.forEach((v) => {
              if (
                v.rewardBaseMoney === "" ||
                (!v.rewardBaseMoney && v.rewardBaseMoney !== 0)
              ) {
                flag = true;
              }
            });
          }

          if (flag) {
            this.$message({
              message: "请商品单件奖励!",
              type: "warning",
            });
          } else {
            this.step = this.step + 1;
          }
        } else {
          this.$message({
            message: "请添加商品!",
            type: "warning",
          });
        }
      } else if (this.step === 4) {
        let params = {};
        params.applyStoreCodes = this.shopList.map((v) => v.storeCode);
        params.ruleGoodsList = this.addGoodsList;
        params.supplierCode = this.$route.query.storeCode;
        this.ruleForm.rewardName = this.ruleForm.rewardName
          .replace("（", "(")
          .replace("）", ")");
        Object.assign(params, this.ruleForm);
        this.$store
          .dispatch("saveSupplierRewardRuleInfoList", params)
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogVisible = false;
              this.queryList();
              this.step = 1;
              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
            }
          });
      }
    },
    sortTime(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return (
          new Date(new Date().toLocaleDateString() + " " + value1).getTime() -
          new Date(new Date().toLocaleDateString() + " " + value2).getTime()
        );
      };
    },
    keep() {},
    swithRunningTimeType() {
      this.$refs.validatorTime.clearValidate();
    },
    getChecked(selection) {
      this.checkedRow = selection;
      // this.checkedRow = selection.map(v => v.spuId);
    },
    addShop() {
      const list = this.checkedMerchantRow;
      let json = this.shopList.concat(list);
      let newJson = [];
      for (let item1 of json) {
        let flag = true;
        for (let item2 of newJson) {
          if (item1.storeCode == item2.storeCode) {
            flag = false;
          }
        }
        if (flag) {
          newJson.push(item1);
        }
      }
      this.shopList = newJson;
      // this.shopList.map(v => {
      //   if (v.storeCode === this.value) {
      //     show = true;
      //   }
      // });
      // if (!show) {
      //   this.shopList.push({
      //     storeName: this.$refs.selectCh.selectedLabel,
      //     storeCode: this.value
      //   });
      // }
      // this.value = "";
      this.merchantDialogVisible = false;
    },
    remove(row) {
      let list = [];
      list.push(row);
      this.shopList = getSubtract(this.shopList, list, "storeCode");
    },
    addGoods() {
      this.dialogVisibleGoods = true;
      // this.queryMicroShopGoodsList();
      this.$store.dispatch("queryHemiaoBrandComboBox", {
        supplierCode: this.$route.query.storeCode,
      });
    },
    searchGoods() {
      this.currentMicroPage = 1;
      this.queryMicroShopGoodsList();
    },
    addMerchandise() {
      this.addGood.storeCode = this.$route.query.storeCode;
      return this.$store
        .dispatch("saveSupplierGoodsInfoList", this.addGood)
        .then((res) => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success",
            });
            this.queryMicroShopGoodsList();
            this.addGood = {};
          }
        });
    },
    getMerchantChecked(selection) {
      this.checkedMerchantRow = selection;
    },
    getDelChecked(selection) {
      this.checkedDelRow = selection.map((v) => v.rewardRuleId);
    },
    batchDelete() {
      if (this.checkedDelRow.length) {
        let say = "删除已选" + this.checkedDelRow.length + "条数据";
        this.$confirm(say, "提示", {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning",
        }).then(() => {
          let params = {
            rewardRuleIds: this.checkedDelRow,
            supplierCode: this.$route.query.storeCode,
          };
          this.$store
            .dispatch("delSupplierRewardRuleInfoList", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });
                this.queryList();
              }
            });
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    openTimeBatch() {
      if (this.checkedDelRow.length) {
        this.dialogVisibleTimeBatch = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    batchSetting() {
      if (!this.batchCondition.endTime && !this.batchCondition.addDays) {
        this.$message({
          message: "请选择结束时间或者请选择活动下线天数",
          type: "warning",
        });
        return;
      }
      let say = "修改已选" + this.checkedDelRow.length + "条数据的结束时间";
      this.$confirm(say, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        let params = {};
        if (this.batchCondition.endTime) {
          params = {
            rewardEndDate: this.batchCondition.endTime,
            rewardRuleIds: this.checkedDelRow,
            // supplierCode: this.$route.query.storeCode,
          };
          console.log("活动结束时间params:", params);
          this.$store
            .dispatch("editRewardRuleEndDateBatch", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });
                this.batchCondition.endTime = "";
                this.dialogVisibleTimeBatch = false;
                this.queryList();
              }
            });
        }
        if (this.batchCondition.addDays) {
          params = {
            rewardRuleIdList: this.checkedDelRow,
            addDays: this.batchCondition.addDays,
            // supplierCode: this.$route.query.storeCode,
          };
          console.log("活动下线天数params:", params);
          this.$store
            .dispatch("batchIncreaseAutoOfflineDaysLimt", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });
                this.batchCondition.endTime = "";
                this.dialogVisibleTimeBatch = false;
                this.queryList();
              }
            });
        }
      });
    },
    editAddGoods() {
      this.dialogVisibleGoods = true;
      this.currentMicroPage = 1;
      this.pageMicroSize = 10;
      this.queryMicroShopGoodsList();
    },
    pagingMicro(page) {
      this.currentMicroPage = page;
      this.queryMicroShopGoodsList();
    },
    handleSizeMicroChange(size) {
      this.currentMicroPage = 1;
      this.pageMicroSize = size;
      this.queryMicroShopGoodsList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryMicroShopGoodsList() {
      let params = {
        pageSize: this.pageMicroSize,
        pageNo: this.currentMicroPage,
        storeCode: this.$route.query.storeCode,
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );

      Object.assign(params, searchDialogCondition);

      return this.$store.dispatch("querySupplierGoodsInfoList", params);
    },
    affirm() {
      if (this.checkedRow.length) {
        this.supplierGoodsInfoCheckGoods(this.checkedRow);

        console.log("this.addGoodsList: ", this.addGoodsList);
        this.dialogVisibleGoods = false;
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning",
        });
      }
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.ruleFormGood;
          params.storeCode = this.$route.query.storeCode;
          return this.$store
            .dispatch("saveSupplierGoodsInfoList", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });

                this.queryMicroShopGoodsList();
                this.dialogVisibleGood = false;
              }
            });
        } else {
          return false;
        }
      });
    },
    removeGoods(row) {
      let list = [];
      list.push(row);
      this.addGoodsList = getSubtract(
        this.addGoodsList,
        list,
        "supplierGoodsId"
      );
      /*this.addGoodsList.splice(index, 1);*/
    },
    filterGt0OrListFixed0(i, prop) {
      if (prop !== "rewardSubNum") {
        this.ruleForm.ruleRelModelList[i][prop] =
          this.ruleForm.ruleRelModelList[i][prop].replace(/^(0+)/, ""); //过滤0开头
      }

      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/[^\d]+/g, "");
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrListFixed2(i, prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.ruleForm.ruleRelModelList[i][prop].indexOf(".") < 0 &&
        this.ruleForm.ruleRelModelList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.ruleRelModelList[i][prop] = parseFloat(
          this.ruleForm.ruleRelModelList[i][prop]
        );
      }
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrGoodsListFixed2(i, prop) {
      this.$forceUpdate();
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.addGoodsList[i][prop].indexOf(".") < 0 &&
        this.addGoodsList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.addGoodsList[i][prop] = parseFloat(this.addGoodsList[i][prop]);
      }
    },
    outputExcelMerchant() {
      this.$store.dispatch("storeActivityList", {
        supplierCode: this.$route.query.storeCode,
      });
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
      }, 0);
    },
  },
};
</script>
<style lang="scss">
.applDepart {
  width: 600px;

  .el-input {
    width: 600px;

    input {
      width: 600px;
    }
  }
}
</style>
<style lang="scss" scoped>
.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.title {
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(34, 34, 34, 1);
}

/deep/ .activity-style {
  background-color: #fce6f0 !important;
}
</style>
